import React from "react";
import { Globe, Check } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "../components/ui/dropdown-menu";
import { Button } from "../components/ui/button";
import { useI18n } from "../i18n";

export default function LanguageSwitcher() {
  const { lang, setLang, langs } = useI18n();
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          data-testid="language-switcher-btn"
          variant="outline"
          className="h-10 w-10 p-0 rounded-full border-border bg-white hover:bg-secondary active:scale-95 transition-transform"
        >
          <Globe className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="rounded-2xl">
        {langs.map((l) => (
          <DropdownMenuItem
            key={l.code}
            data-testid={`lang-option-${l.code}`}
            onClick={() => setLang(l.code)}
            className="cursor-pointer gap-2 text-sm"
          >
            <span className="w-4">{lang === l.code && <Check className="h-3.5 w-3.5" />}</span>
            {l.name}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
